// Ember imports
import Route from '@ember/routing/route';

export default class MyProfileRoute extends Route {}
